import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import logoDark from '../../assets/logoDark.png';
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from 'react';
import './navStyle.css';
function Navigation(props) {
  const location = useLocation();
  const [main, setMain] = useState(false);
  useEffect(() => {
    if (location.pathname === '/disc') {
      setMain(true);
    }
    //console.log('run')
  }, [location.pathname]);
  return (
    <Navbar fixed={props.loc} collapseOnSelect expand="lg" bg="dark" variant="dark" >
      <Container >
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">

          {/* <Nav className="me-auto">
            <Nav.Link href="https://discord.com/invite/NcdH2GyShp" target="_blank" style={{ color: 'white' }}>PERSONALITY | DISCORD</Nav.Link>
          </Nav> */}
          <Nav className="me-auto">
            <Link to={main ? '/disc' : "/"} style={{ textDecoration: 'none', color: 'white'}}>
              <button className='navButt py-2 rounded-4' 
                style={{ width: '12.5rem', backgroundColor: 'orange' , color:'black'  }}>
                {main ? 'DISC | EFFICIENCY' : 'Personality | Calculator'}</button>
            </Link>
          </Nav>

          <Nav className="me-auto">
            <Nav.Link href="https://tarockapp.com/" target="_blank"> <img src={logoDark} alt={'tarock'} height='70px' /> </Nav.Link>
          </Nav>

          <Nav >
            <Link to={main ? '/' : "/disc"} style={{ textDecoration: 'none', color: 'white' }}>
              <button className='navButt py-2 rounded-4' 
              style={{ width: '12.5rem', backgroundColor: main ?'red':'green', color: 'white'  }}>
                {main ? 'Personality | Calculator' : 'DISC | EFFICIENCY'}</button>
            </Link>
          </Nav>

        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navigation;